/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Export_AbortedInputs */

const en_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle export was aborted`)
};

const fr_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’exportation des sous-titres a été annulée`)
};

const de_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Export der Untertitel wurde abgebrochen.`)
};

const it_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione dei sottotitoli è stata interrotta`)
};

const ru_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров был прерван.`)
};

const es_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló la exportación de subtítulos`)
};

const zh_cn2_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出已中止`)
};

const ja_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートが中止されました`)
};

const hi_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात रद्द कर दिया गया`)
};

const pt_pt2_work_order_publish_export_aborted = /** @type {(inputs: Work_Order_Publish_Export_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação de legendas foi cancelada.`)
};

/**
* | output |
* | --- |
* | "Subtitle export was aborted" |
*
* @param {Work_Order_Publish_Export_AbortedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_export_aborted = /** @type {((inputs?: Work_Order_Publish_Export_AbortedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Export_AbortedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_export_aborted(inputs)
	if (locale === "de") return de_work_order_publish_export_aborted(inputs)
	if (locale === "it") return it_work_order_publish_export_aborted(inputs)
	if (locale === "ru") return ru_work_order_publish_export_aborted(inputs)
	if (locale === "es") return es_work_order_publish_export_aborted(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_export_aborted(inputs)
	if (locale === "ja") return ja_work_order_publish_export_aborted(inputs)
	if (locale === "hi") return hi_work_order_publish_export_aborted(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_export_aborted(inputs)
	return en_work_order_publish_export_aborted(inputs)
});